import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { environment } from "environments/environment";
import { Subject } from "rxjs/Rx";

@Injectable()

export class BrightserveInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const authReq = request.clone({
            url: environment.apiOrigin + request.url,
        });

        return next.handle(authReq);
    }
}



// WEBPACK FOOTER //
// ./src/app/brightserve/brightserve-interceptor.ts